var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notice-img"},[(_vm.name)?_c('img',{attrs:{"src":_vm.img(("icons/" + (_vm.getName(_vm.name)) + ".png")),"width":_vm.width}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }